module.exports = __webpack_public_path__ + "img/3.601f10f6.png";